export function skillScoreRounding(score: number): number {
  const scoreString = score?.toFixed(1);

  if (scoreString?.endsWith('.0')) return Math.round(score);
  return parseFloat(scoreString);
}
